import { ReactElement } from 'react'

import CreateUsuarioImpl from 'modules/user/domain/usecases/CreateUsuarioImpl'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import CreateUsuario from 'modules/user/pages/CreateUsuario'

export const CreateUsuarioFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const createUsuarioImpl = new CreateUsuarioImpl(userRepository)

  return <CreateUsuario createUsuario={createUsuarioImpl} />
}
